import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import AnalyticsApi from "../../apis/analytics.api";
import MonthlySelect from "../../components/MonthlySelect";
import Dropdown from "../../components/dropdown/Dropdown";
import DropdownOption from "../../components/dropdown/DropdownOption";
import { CEO_TYPES, DATE_FORMAT } from "../../constants/AppConstants";
import useAuth from "../../hooks/useAuth";
import AnalyticsChart from "./AnalyticsChart";
import AnalyticsTopNav from "./AnalyticsTopNav";

const Analytics = () => {
  const [active, setActive] = useState("full");
  const { ceoInfo } = useAuth();
  const [selectedDate, setSelectedDate] = useState({
    startDate: "",
    endDate: "",
  });

  const [selectedStore, setSelectedStore] = useState(null)

  const [data, setData] = useState([]);
  const [stores, setStores] = useState([]);

  const formatValue = (value) => {
    if (!value) return 0;
    return parseFloat(value).toFixed(2).toLocaleString();
  };

  const getTheGreatestValue = (list, fieldName) => {
    list.sort(function (a, b) {
      return a.month - b.month;
    });
    const largest = list[list.length - 1];
    if (!largest) return 0;
    return fieldName === "reviewCnt" ? largest?.[fieldName] : formatValue([largest?.[fieldName]]) || 0;
  };

  const genSeries = (fields, data) =>
    fields.map((name) => {
      return {
        name,
        data: data.map((o) => {
          return formatValue(o[name]);
        }),
      };
    });

  const getData = async () => {
    if (ceoInfo?.shop_idx && selectedDate.startDate && selectedDate.endDate) {
      const res = await AnalyticsApi.get({
        store_idx: active === 'full' ? null : selectedStore,
        shop_idx: ceoInfo?.shop_idx,
        start_date: moment(selectedDate.startDate).format(DATE_FORMAT.YYYYMMDD),
        end_date: moment(selectedDate.endDate).format(DATE_FORMAT.YYYYMMDD),
      });
      const getYm = (d) => {
        const year = moment(d).year();
        const month = moment(d).month() + 1;
        return year * 100 + month;
      }
      window.moment = moment;
      const d1 = new Date(selectedDate.startDate);
      d1.setDate(0);
      let ym1 = getYm(d1);
      let ym2 = getYm(selectedDate.endDate);
      let ls = [];
      let count = 0;

      while (ym1 <= ym2 && count++ < 100) {
        ls.push(ym1 + "");
        if ((ym1 % 100) % 12 == 0) {
          ym1 = ym1 + 100 - 11;
        } else {
          ym1++;
        }
      }

      // {
      //   "averageRating": [
      //     {
      //       "average_rating": 4.9447513,
      //       "month": "202403"
      //     },
      //     {
      //       "average_rating": 4.94926,
      //       "month": "202404"
      //     }
      //   ],
      //   "generalReviews": [
      //     {
      //       "reviewCnt": 171,
      //       "month": "202403"
      //     },
      //     {
      //       "reviewCnt": 912,
      //       "month": "202404"
      //     }
      //   ],
      //   "specialReviews": [
      //     {
      //       "reviewCnt": 10,
      //       "month": "202403"
      //     },
      //     {
      //       "reviewCnt": 34,
      //       "month": "202404"
      //     }
      //   ]
      // }

      const tmp = res.data.data ?? {};
      // // add missing data
      for (const x of ["averageRating", "generalReviews", "specialReviews"]) {
        if (!tmp[x]) tmp[x] = [];

        for (let kk of ls) {
          if (!tmp[x].find(k => k.month == kk)) {
            tmp[x].push({ month: kk, reviewCnt: 0, average_rating: 0 });
          }
        }
      }
      setData(tmp);
    }
  };

  const getStores = async () => {
    if (ceoInfo?.shop_idx) {
      const res = await AnalyticsApi.getStores(ceoInfo?.shop_idx);
      if (res.data.data.length > 0) {
        setStores(res.data.data);
        setSelectedStore(res.data.data?.[0]?.store_idx)
      }
    }
  };

  useEffect(() => {
    getData();
  }, [selectedDate.startDate, selectedDate.endDate, selectedStore]);

  useEffect(() => {
    if (active === "shop" && stores.length === 0) {
      getStores();
    }
    getData();
  }, [active]);

  return (
    <div>
      <AnalyticsTopNav />
      <div className="p-10 pb-0">
        <MonthlySelect
          setSelectedDate={(start, end) =>
            setSelectedDate({ startDate: start, endDate: end })
          }
        />
      </div>
      <div className="flex items-center mt-5 bg-[#F8F9FC] radius-rounded px-2">
        <button
          onClick={() => setActive("full")}
          className={`py-3 ${active === "full" ? "outline-blue-btn2" : "contained-blue"
            }`}
        >
          전체 통계
        </button>
        <button
          onClick={() => setActive("shop")}
          className={`py-3 ${active === "shop" ? "outline-blue-btn2" : "contained-blue"
            }`}
        >
          매장별 통계
        </button>
      </div>
      <div className="pb-16 px-2">
      {/* {active === "shop" && (
          <select
            onChange={(e) => setSelectedStore(e.target.value)}
            className="app-dropdown mt-5"
          >
            {stores?.map((item) => (
              <option key={item.store_idx} value={item.store_idx}>
                [{item.app_name}] {item.store_name}
              </option>
            ))}
          </select>
        )} */}
        {active === "shop" && (
          <Dropdown            
            className="mt-5"
            value={(function() {
              const item = stores?.find(x => x.store_idx == selectedStore);
              if (!item) return "";
              return `[${item.app_name}] ${item.store_name}`;
            }())}
          >
            {stores?.map((item) => (
              <DropdownOption key={item.store_idx} value={item.store_idx} 
                onClick={() => setSelectedStore(item.store_idx)}>
                [{item.app_name}] {item.store_name}
              </DropdownOption>
            ))}
          </Dropdown>
        )}


        {data?.averageRating && (
          <div className="mt-4">
            <div className="review-card2 ">
              <p className="flex justify-between items-center">
                <b className="text-lg">리뷰 평점</b>
                <b className="text-2xl">
                  {getTheGreatestValue(data?.averageRating, "average_rating")}점
                </b>
              </p>
              <div className="px-10">
                <AnalyticsChart
                  series={genSeries(["average_rating"], data?.averageRating)}
                  categories={data?.averageRating.map(
                    (x) => moment(x.month).format("M") + "월"
                  )}
                />
              </div>
            </div>
          </div>
        )}

        {data?.generalReviews && (
          <div className="mt-4">
            <div className="review-card2 ">
              <p className="flex justify-between items-center">
                <b className="text-lg">일반 리뷰 수</b>
                <b className="text-2xl">
                  {getTheGreatestValue(data?.generalReviews, "reviewCnt")}개
                </b>
              </p>
              <div className="px-10">
                <AnalyticsChart
                  series={genSeries(["reviewCnt"], data?.generalReviews)}
                  categories={data?.generalReviews.map(
                    (x) => moment(x.month).format("M") + "월"
                  )}
                />
              </div>
            </div>
          </div>
        )}

        {data?.specialReviews && ceoInfo?.ceo_type === CEO_TYPES.PREMIUM && (
          <div className="mt-4">
            <div className="review-card2 ">
              <p className="flex justify-between items-center">
                <b className="text-lg">관심 리뷰 수</b>
                <b className="text-2xl">
                  {getTheGreatestValue(data?.specialReviews, "reviewCnt")}개
                </b>
              </p>
              <div className="px-10">
                <AnalyticsChart
                  series={genSeries(["reviewCnt"], data?.specialReviews)}
                  categories={data?.specialReviews.map(
                    (x) => moment(x.month).format("M") + "월"
                  )}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Analytics;
